export const cars =[
    {
        image: "/images/Hyundai_Creta/1.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/Hyundai_Creta/2.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/Hyundai_Creta/3.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/Hyundai_Creta/4.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/Hyundai_Creta/5.jpg",
        // title: "Toyota Prado"
    }
];